import { useAuth0 } from '../../contexts/Auth0Context'

export async function useCurrentExpert() {
  const { user } = useAuth0()
  const expertPortalUrl = process.env.REACT_APP_EXPERT_PORTAL_URL
  const paroAppUrl = process.env.REACT_APP_PARO_APP_URL
  const formstackUrl = process.env.REACT_APP_FORMSTACK_URL
  const USER_METADATA_URI = `${process.env.REACT_APP_USER_METADATA_URI}/user_metadata`
  const rolesURI = `${process.env.REACT_APP_USER_METADATA_URI}/roles`
  const roles = user[rolesURI]

  if (roles.includes('expert_active')) {
    window.location.replace(`${expertPortalUrl}/dashboardsV2`)
    return
  }

  if (roles.includes('expert_rejected')) {
    window.location.replace(`${paroAppUrl}/applicant/rejected`)
    return
  }

  if (roles.includes('expert_candidate')) {
    window.location.replace(`${paroAppUrl}/freelancer/apply/registration-review`)
    return
  }

  if (roles.includes('expert_applicant')) {
    const userMetadata = user[USER_METADATA_URI]
    window.location.replace(userMetadata?.formstack_url || formstackUrl)
  }
}
